import { memo } from 'react';

import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

function EmptyPayee({ handleAddPayee, hasButton = true }) {
  return (
    <Stack
      alignItems="center"
      alignSelf="center"
      direction="column"
      paddingTop="32px"
      spacing="16px"
      width="320px"
    >
      <Text
        align="center"
        color="secondary"
        size="xl"
        weight="medium"
      >
        You don&apos;t have any payees
      </Text>
      <Text
        align="center"
        color="secondary"
        size="md"
      >
        You need to add a contact before you can transfer money between bank accounts.
      </Text>
      {hasButton && (
        <Button
          aria-label="add payee action"
          color="info"
          onClick={handleAddPayee}
          size="small"
          variant="text"
        >
          Add Payee
        </Button>
      )}
    </Stack>
  );
}

export default memo(EmptyPayee);

EmptyPayee.propTypes = {
  handleAddPayee: PropTypes.func.isRequired,
  hasButton: PropTypes.bool
};
